import React from "react";

export default function PayrollTableEmpty({ title = "No records found" }) {
  return (
    <div className="payroll-empty">
      <h4>{title}</h4>
      <p>Once data is added, it will appear here.</p>
    </div>
  );
}
